import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Suspense } from 'react';

import { RumComponentContextProvider } from '@mint-lib/datadog';
import { useTranslation } from '@mint-lib/i18n';
import { QueryClientProvider } from '@mint-lib/query-client';
import { useService } from '@mint-lib/routing-context';
import { SlotPortal } from '@mint-lib/slots';
import { Outlet } from '@mint/routing';

import { MainLayout } from '../components/atoms/MainLayout.jsx';
import { CustomMetricsDrawer } from '../components/organisms/CustomMetricsDrawer.jsx';
import { CustomMetricsDrawerProvider } from '../contexts/CustomMetricsContext.jsx';
import { useImportHubV2 } from '../hooks/ff/index.js';

export function ImportHubLayout() {
  const { t } = useTranslation('@myn/import-hub');
  const isImportHubV2 = useImportHubV2();

  const [queryClient] = useService({
    name: 'queryClient',
    suspense: true,
  });

  const layout = (
    <MainLayout>
      <SlotPortal name="topBarTitle">{t('Data Import Hub')}</SlotPortal>
      <Outlet />
      {!isImportHubV2 && <CustomMetricsDrawer />}
    </MainLayout>
  );

  return (
    <Suspense>
      <RumComponentContextProvider componentArea="import-hub">
        <QueryClientProvider client={queryClient}>
          {/* Import Hub v2 custom metrics come from MDM, not the legacy drawer */}
          {isImportHubV2 ? (
            layout
          ) : (
            <CustomMetricsDrawerProvider>{layout}</CustomMetricsDrawerProvider>
          )}
          <ReactQueryDevtools initialIsOpen={true} />
        </QueryClientProvider>
      </RumComponentContextProvider>
    </Suspense>
  );
}
